export default {
  name: 'Skeleton',
  props: {
    animation: {
      type: [String, Boolean],
      default: 'wave',
      validator: val => ['wave', false].includes(val)
    },
    h: {
      type: String,
      default: '20px'
    },
    isLoaded: {
      type: Boolean,
      default: false
    },
    m: {
      type: String,
      default: '0px'
    },
    rep: {
      type: Number,
      default: 1
    },
    radius: {
      type: String,
      default: '4px'
    },
    skeletonClass: {
      type: String,
      default: ''
    },
    transition: {
      type: Boolean,
      default: true
    },
    w: {
      type: String,
      default: '100%'
    },
    bgColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.16)',
      required: false
    }
  },
  computed: {
    componentClass () {
      return [
        this.skeletonClass,
        'skeleton',
        this.animation ? `skeleton--${this.animation}` : null
      ]
    },
    componentStyle () {
      return {
        width: this.w,
        height: this.h,
        borderRadius: this.radius,
        margin: this.m,
        background: this.bgColor
      }
    },
    hasChild () {
      return this.$slots && this.$slots.default
    }
  }
}
